<template>
  <div
    v-if="deluge.canvaspro_core_info?.product_name"
    class="login-container">
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      ">
      <img
        @load="handleLoad"
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge.canvaspro_core_info?.product_name.toUpperCase() === 'OMNI'"
        :src="omniSvg" />
      <img
        @load="handleLoad"
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge.canvaspro_core_info?.product_name.toUpperCase() === 'ONE'"
        :src="oneSvg" />
      <img
        @load="handleLoad"
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge.canvaspro_core_info?.product_name.toUpperCase() === 'ORB'"
        :src="orbSvg" />
      <div
        style="color: white; font-size: 24px; font-weight: bolder"
        class="CanvasProFont">
        Welcome to CanvasPro
        {{ toTitleCase(deluge?.canvaspro_core_info?.product_name) }}
      </div>
      <div
        style="padding-bottom: 0px; color: white; opacity: 0.5"
        class="CanvasProFont"></div>
      <div
        style="padding-bottom: 50px; color: white; opacity: 0.8; display: flex"
        class="CanvasProFont">
        <div
          style="opacity: 0.6; font-weight: bold"
          class="mr-2">
          {{ hintnum }}
        </div>
        {{ hint }}
      </div>
      <form>
        <v-text-field
          autofocus
          v-on:keyup.enter="login"
          filled
          bg-color="white"
          style="width: 300px"
          v-model="username"
          clearable
          autocomplete="username"
          label="Username"></v-text-field>
        <v-text-field
          v-on:keyup.enter="login"
          filled
          bg-color="white"
          style="width: 300px"
          v-model="password"
          clearable
          dark="true"
          label="Password"
          aria-autocomplete="current-password"
          autocomplete="current-password"
          type="password"
          @keydown="handleKeyEvent"
          @keyup="handleKeyEvent"
          @focus="handleFocus"
          @blur="handleBlur"></v-text-field>
        <div
          v-if="capsLockOn"
          class="caps-warning"
          role="status"
          aria-live="polite">
          Warning: Caps Lock is on
        </div>
      </form>
      <div style="width: 300px">
        <v-btn
          :loading="login_loading"
          class="my-3"
          variant="flat"
          block
          color="primary"
          @click="login()">
          Login
        </v-btn>
      </div>
    </div>
  </div>
  <div
    class="CanvasProFont"
    style="
      position: absolute;
      bottom: 10px;
      right: 20px;
      color: white;
      opacity: 0.5;
      font-weight: bolder;
      font-size: 20px;
    ">
    v{{ state?.version }}
  </div>
  <div
    class="CanvasProFont"
    style="
      position: absolute;
      bottom: 10px;
      left: 20px;
      color: white;
      opacity: 0.5;
      font-weight: bolder;
      font-size: 20px;
    ">
    {{ state?.machine_name }}
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { deluge, state } from '@/stores/deluge.js';
import omniSvg from '../../assets/OmniLight.svg';
import oneSvg from '../../assets/OneLight.svg';
import orbSvg from '../../assets/CanvasPro_Orb_Anagram_White_7680px.svg';
const emit = defineEmits(['success']);
const login_loading = ref(false);
const username = ref('');
const password = ref('');
const capsLockOn = ref(false);
const forgot_password = ref(false);
const imgLoaded = ref(false);
let text = '';
function random_hint() {
  const number = Math.floor(Math.random() * hints.length);
  text = hints[number];
  hintnum = `#${number}`;

  return text;
}
const hints = [
  "'Ctrl + Q' in OnAir opens up the new queue dialog",
  'Adding an asset to a queue? You are actually creating a scene and CanvasPro is choosing the template for you',
  "To keep everything running smoothly don't forget to delete unused items!",
  'You can "nest" queues within each other by dragging a queue into another queue',
  '"Overrides" can be used to set default settings for items inside queues',
  'Power user? Enable the console window to access more options',
  'CanvasPro One is our answer to real-time content management & playback',
  'CanvasPro Omni is our answer to centralized management of real-time content',
  'Channels are content controllers, frames display the item the channel chooses to play',
  "Channel conditions are functional even when they aren't assigned to a frame",
  'Customize your templates with icons and thumbnails to make it clear what they do',
  'Scenes inherit variables from their parent template, use the variable lock button to control this',
  'Use the interact (touch icon) in OnAir to interact with the live scene in real-time!',
  'You can create custom assets to store formats such as JSON, Text, and Live Feeds',
  'For optimal performance & stability, always use video formats optimized for real-time such as HAP and NotchLC',
  'Custom conditions for scenes and queues can be created with CanvasPro Apps',
  "Custom templates and custom apps can be utilized to extend CanvasPro's functionality to meet your needs",
  'Low on RAM? turn on "Prioritize Memory Usage" in the settings of heavy templates',
  'CanvasPro can be used to control the state of a single template using template self swap mode',
  'Use Cue/Take workflows to preview content before it goes live',
  'The clock at the bottom shows the current time in the timezone of the server',
  'Use a combination of conditions to create complex playout logic',
  "Press the information button in UI to get more information about what you're looking at",
];
var hintnum = 'Hint #0';
const hint = random_hint();
let prependUrl = '';
if (import.meta.env.DEV) {
  prependUrl = '/api';
}
onMounted(() => {
  username.value = localStorage.getItem('username');
});
function toTitleCase(str) {
  if (!str) return '';
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
function handleLoad() {
  imgLoaded.value = true;
}
function login() {
  login_loading.value = true;
  const FD = new FormData();
  var request = new XMLHttpRequest();
  FD.append('username', username.value);
  FD.append('password', password.value);
  request.open('POST', state.devRedirect + '/api/token', FD);
  request.onload = () => {
    if (request.status !== 200) {
      login_loading.value = false;
      alert('Username or password denied');
    }
    var respObj = JSON.parse(request.responseText);
    if ('access_token' in respObj) {
      localStorage.setItem('username', username.value);
      localStorage.setItem('authentication_token', respObj.access_token);

      emit('success', respObj);
    }
  };
  request.onerror = () => {
    alert('Username or password denied');
  };
  request.send(FD);
}

function handleKeyEvent(e) {
  try {
    const on = e.getModifierState && e.getModifierState('CapsLock');
    capsLockOn.value = !!on;
  } catch (err) {
    capsLockOn.value = false;
  }
}

function handleFocus(e) {
  capsLockOn.value = false;
}

function handleBlur() {
  capsLockOn.value = false;
}
</script>
<style>
.login-container {
  height: 100vh;
  height: 100dvh;
  height: -webkit-fill-available;
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  background: #1a1a1f;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 1;
  z-index: 1000;
}
.forgot-password-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9999999;
  opacity: 1;
  background: var(--main-bg-color);
}
.caps-warning {
  color: #f50b0b;
  font-size: 0.9rem;
  margin-top: 6px;
  width: 300px;
  text-align: left;
}
</style>
